import { connect } from 'react-redux';
import { NavLink, useLocation } from "react-router-dom";
import { AI_CONFIGURATION_PREPEND, CONFIGURATION_PREPEND, CONFIGURATION_ROUTER_URL, FACULTY_PREPEND, FACULTY_ROUTER_URL, FRESHMAN_PREPEND, FRESHMAN_ROUTER_URL, ROUTER_URL, STAFF_PREPEND, STAFF_ROUTER_URL, STUDENT_PREPEND, STUDENT_ROUTER_URL } from "./../constants/routerUrl";
import { UserTypes } from '../models/dashboard/adminDashboard';
import { UserRole } from '../constants/RoleEnum';
import { collegeType } from '../constants/collegeType';

const AdminTabs = (props: any) => {
  const { currentRole, currentManagementType } = props;
  const location = useLocation();
  return (
    <>{
      !((location.pathname == ROUTER_URL.FEEDBACK) || (location.pathname == ROUTER_URL.ADMIN_SETTINGS)) && (
        <ul className="admin-tabs">
          {(currentRole == UserRole.SuperAdmin || currentRole == UserRole.CollegeAdmin) && <li>
            <NavLink to={currentRole == UserRole.SuperAdmin ? ROUTER_URL.COLLEGE_INDEX : ROUTER_URL.COLLEGE_DETAILS}>University Management</NavLink>
          </li>}
          {(currentRole == UserRole.SuperAdmin || currentRole == UserRole.DepartmentAdmin) && <li>
            {currentRole == UserRole.SuperAdmin && <NavLink to={ROUTER_URL.DEPARTMENT_INDEX}>Department</NavLink>}
            {currentRole == UserRole.DepartmentAdmin && <NavLink to={ROUTER_URL.DEPARTMENT_DETAILS}>Department</NavLink>}
          </li>}
          {(currentRole == UserRole.SuperAdmin || currentRole == UserRole.DepartmentAdmin) && <li>
            <NavLink
              to={currentRole == UserRole.SuperAdmin ? CONFIGURATION_ROUTER_URL.BUTTON_INDEX : CONFIGURATION_ROUTER_URL.NOTIFICATION_INDEX}
              className={
                location.pathname.startsWith(CONFIGURATION_PREPEND)
                  ? "active"
                  : ""
              }
            >
              Configuration
            </NavLink>
          </li>}
          {(currentRole == UserRole.SuperAdmin) && <li>
            <NavLink
              to={ ROUTER_URL.AI_CONFIGURATION}
              className={
                location.pathname.startsWith(AI_CONFIGURATION_PREPEND)
                  ? "active"
                  : ""
              }
            >
              AI Configuration
            </NavLink>
          </li>}
          {(currentRole == UserRole.SuperAdmin || currentRole == UserRole.DepartmentAdmin) && <li>
            <NavLink
              to={STAFF_ROUTER_URL.BUTTON_PRIORITY}
              state={{ userRole: UserTypes.Staff }}
              className={
                location.pathname.startsWith(STAFF_PREPEND) ? "active" : ""
              }
            >
              Staff
            </NavLink>
          </li>}
          {(currentRole == UserRole.SuperAdmin || (currentRole == UserRole.CollegeAdmin && currentManagementType != collegeType.universityAdministration)) && <li>
            <NavLink
              to={STUDENT_ROUTER_URL.BUTTON_PRIORITY}
              state={{ userRole: UserTypes.Student }}
              className={
                location.pathname.startsWith(STUDENT_PREPEND)
                  ? "active"
                  : ""
              }
            >
              Student
            </NavLink>
          </li>}
          {!((currentRole === UserRole.CollegeAdmin || currentRole === UserRole.DepartmentAdmin) && currentManagementType === collegeType.universityAdministration) && (
          <li>
            <NavLink
              to={(currentRole == UserRole.SuperAdmin || currentRole == UserRole.CollegeAdmin) ? FACULTY_ROUTER_URL.BUTTON_PRIORITY : FACULTY_ROUTER_URL.REPORT_PRIORITY}
              state={{ userRole: UserTypes.Faculty }}
              className={
                location.pathname.startsWith(FACULTY_PREPEND)
                  ? "active"
                  : ""
              }
            >
              Faculty
            </NavLink>
          </li>
          )}
          {currentRole === UserRole.SuperAdmin && (
            <li>
              <NavLink
                to={FRESHMAN_ROUTER_URL.FRESHMAN_CONFIGURATION_INDEX}
                className={
                  location.pathname.startsWith(FRESHMAN_PREPEND)
                    ? "active"
                    : ""
                }>
                Freshman
              </NavLink>
            </li>
          )}
        </ul>)
    }
    </>
  );
};

const mapStateToProps = (state: any) => ({
  currentRole: state.userDetails.userProfileData?.currentRole,
  currentManagementType: state.userDetails.userProfileData.currentCollege?.managementType
});

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTabs);